export const GET_TAGS_SUCCESS = "GET_TAGS_SUCCESS";
export const APPEND_TAGS_SUCCESS = "APPEND_TAGS_SUCCESS";
export const CLEAR_TAGS = "CLEAR_TAGS";
